import * as BOM_API from '@/api/bom'

export default {
  state: {
    customerBomFile: null,
    customerBomFileWithVersion: null
  },
  getters: {
    customerBomFile: state => state.customerBomFile,
    customerBomFileWithVersion: state => state.customerBomFileWithVersion
  },
  mutations: {
    setCustomerBomFile (state, customerBomFile) {
      state.customerBomFile = customerBomFile
    },
    setCustomerBomFileWithVersion (state, customerBomFileWithVersion) {
      state.customerBomFileWithVersion = customerBomFileWithVersion
    }
  },
  actions: {
    async createCustomerBomFile ({ commit }, data) {
      let response = await BOM_API.createCustomerBomFile(data)
      commit('setCustomerBomFile', response.data)
      return response.data
    },
    async getCustomerBomFile ({ commit }, fileId) {
      let response = await BOM_API.getCustomerBomFile(fileId)
      commit('setCustomerBomFile', response.data)
      return response.data
    },
    async updateCustomerBomFile ({ commit }, data) {
      let response = await BOM_API.updateCustomerBomFile(data)
      commit('setCustomerBomFile', response.data)
      return response.data
    },
    async saveCustomerBomFile ({ commit }, { id, rows, editedRows }) {
      let response = await BOM_API.saveCustomerBomFileTree({ id: id, data: rows })
      if (editedRows.length > 0) {
        response = await BOM_API.saveCustomerBomFileData({ id: id, data: editedRows })
      }
      commit('setCustomerBomFile', response.data)
      return response.data
    },
    async finishCustomerBomFileTree ({ commit }, fileId) {
      let response = await BOM_API.finishCustomerBomFileTree(fileId)
      commit('setCustomerBomFile', response.data)
      return response.data
    },
    async getCustomerBomFileWithVersion ({ commit }, { fileId, version }) {
      let response = await BOM_API.getCustomerBomFileWithVersion({ fileId, version })
      commit('setCustomerBomFileWithVersion', response.data)
      return response.data
    }
  }
}
